/**
 * Ansökan om andrahandsuthyrning — composition.
 *
 * Connected under a bostadshyresavtal. The parent's hyresgäst(er) become the
 * applicants (`lessor` 0/1 of the future andrahandsavtal); the proposed
 * sub-tenant (`lessee` 0) is new. The landlord is the addressee, not a party.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Ansökan om andrahandsuthyrning';
const FORM_NUMBER = 'Formulär R-08';
const KEY = 'ansokan_andrahand';
const PREAMBLE = 'Förstahandshyresgästen ansöker härmed om hyresvärdens samtycke till andrahandsuthyrning av nedan angiven lägenhet.';
export const ansokanAndrahandV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: KEY,
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Andrahandsuthyrning',
        shortTitle: 'Ansökan andrahandsuthyrning',
        formNumber: FORM_NUMBER,
        signingMode: 'manual_delivery',
        signingPlacementAnchors: 'per-party-label',
        preamble: PREAMBLE,
        description: 'Förstahandshyresgästens ansökan till hyresvärden om att hyra ut lägenheten i andra hand.',
        numberStyle: 'paragraph',
        partySlots: [
            {
                id: 'lessor_primary',
                label: 'Förstahandshyresgäst (kontraktsinnehavare)',
                signingLabel: 'Hyresgäst 1',
                role: 'lessor',
                ordinal: 0,
                required: true,
                signs: true,
                help: 'I andrahandsavtalet blir kontraktsinnehavaren hyresvärd.',
            },
            {
                id: 'lessor_co',
                label: 'Medsökande kontraktsinnehavare',
                signingLabel: 'Eventuell hyresgäst 2',
                role: 'lessor',
                ordinal: 1,
                signs: true,
                help: 'Valfritt — lägg till om förstahandskontraktet har två hyresgäster.',
            },
            {
                id: 'lessee',
                label: 'Föreslagen andrahandshyresgäst',
                signingLabel: 'Andrahandshyresgäst',
                role: 'lessee',
                ordinal: 0,
                required: true,
                signs: true,
                help: 'Den person som ska hyra lägenheten i andra hand.',
            },
        ],
        propertySlots: [{ id: 'property', label: 'Lägenhet (fastighet)', multi: false, required: true }],
        connectedTo: ['bostadshyra'],
        inheritFromParent: {
            parties: [
                { role: 'lessor', ordinal: 0, fromRole: 'lessee', fromOrdinal: 0 },
                { role: 'lessor', ordinal: 1, fromRole: 'lessee', fromOrdinal: 1 },
            ],
            property: true,
            values: [{ key: 'apartment_official_number', fromParentKey: 'property_official_apt_no' }],
        },
        titleSuffix: { key: 'apartment_official_number', prefix: 'lgh' },
        status: 'draft',
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        { instanceId: 'sokande', blockRef: `${KEY}.sokande@v1`, input: {} },
        { instanceId: 'skal-for-uthyrning', blockRef: `${KEY}.skal-for-uthyrning@v1`, input: {} },
        { instanceId: 'onskad-uthyrningstid', blockRef: `${KEY}.onskad-uthyrningstid@v1`, input: {} },
        { instanceId: 'adress-under-uthyrningstiden', blockRef: `${KEY}.adress-under-uthyrningstiden@v1`, input: {} },
        { instanceId: 'hyresbetalning-under-uthyrningen', blockRef: `${KEY}.hyresbetalning-under-uthyrningen@v1`, input: {} },
        { instanceId: 'foreslagen-andrahandshyresgast', blockRef: `${KEY}.foreslagen-andrahandshyresgast@v1`, input: {} },
        {
            instanceId: 'forutsattningar-for-andrahandsuthyrning',
            blockRef: `${KEY}.forutsattningar-for-andrahandsuthyrning@v1`,
            input: {},
        },
        {
            instanceId: 'samtycke-till-personuppgiftsbehandling',
            blockRef: `${KEY}.samtycke-till-personuppgiftsbehandling@v1`,
            input: {},
        },
        { instanceId: 'intygande', blockRef: `${KEY}.intygande@v1`, input: {} },
        {
            instanceId: 'underskrift-av-kontraktsinnehavaren',
            blockRef: `${KEY}.underskrift-av-kontraktsinnehavaren@v1`,
            input: {},
        },
        {
            instanceId: 'underskrift-av-den-foreslagna-andrahandshyresgasten',
            blockRef: `${KEY}.underskrift-av-den-foreslagna-andrahandshyresgasten@v1`,
            input: {},
        },
    ],
});
//# sourceMappingURL=ansokan_andrahand.js.map